import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function ProtectedRoute({
  children,
  allowedRoles,
}: {
  children: React.ReactNode;
  allowedRoles?: Array<"ADMIN" | "COACH" | "CLIENT">;
}) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="fullscreen-message">Cargando aplicación...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={user.role === "CLIENT" ? "/client" : "/dashboard"} replace />;     
  }

  return <>{children}</>;
}
